import { render } from "./EntryLoalImage.vue?vue&type=template&id=1b6b5824&scoped=true"
import script from "./EntryLoalImage.vue?vue&type=script&lang=js"
export * from "./EntryLoalImage.vue?vue&type=script&lang=js"

import "./EntryLoalImage.vue?vue&type=style&index=0&id=1b6b5824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6b5824"]])

export default __exports__